<!--
 * @Author: Merlin
 * @Date: 2024-03-26 19:15:19
 * @LastEditors: Merlin
 * @LastEditTime: 2024-05-09 16:47:02
 * @Description: 这是 pro 模式特殊押注胜利后的弹出气泡 
-->
<template>
    <div class="sidebet-win"
        style="max-height: 61px"
    >
        <div class="sidebet-win-block"
            name="● perfect pair"
            v-if="round._id && oWinningInfo.visible && oWinningInfo.pairsMulty"
        >
            <p>{{ t.GameBlackJack.SidebetWin }}</p>
            <h3>
                {{ t.GameBlackJack.PerfectPair }} <span>x{{ oWinningInfo.pairsMulty }} </span>
            </h3>
        </div>
        <!-- 上下分界 -->
        <div class="sidebet-win-block"
            name="● 21 + 3"
            v-if="round._id && oWinningInfo.visible && oWinningInfo.tripleMulty"
        >
            <p>{{ t.GameBlackJack.SidebetWin }}</p>
            <h3>
                21+3 <span>x{{ oWinningInfo.tripleMulty }} </span>
            </h3>
        </div>
    </div>
</template>

<script lang="ts" setup>
import useTranslation from '~/i18n/useTransLation';
import type { RoundDataInterface } from '../ts/blackjackGame';

const isDev = import.meta.dev;
const props = defineProps({
    round: {
        type: Object as PropType<RoundDataInterface>,
        required: true,
        default: ()=>({}), 
    },
});

const t = useTranslation();
const oWinningEmptyObj = ({
    pairsMulty: 0,
    tripleMulty: 0,
    createdAt: 0,
    visible: false,
});
const oWinningInfo = reactive({
    ...oWinningEmptyObj,
});

watch(
    () => props.round,
    (oNewRound, oOldRound) => {
        // console.log("新旧游戏ID：", oNewRound._id, '=>', oOldRound._id); 
        // console.log("新游戏：", deepCopy(oNewRound));  
        const {
            _id,
            pairsWinAmount = 0,
            tripleWinAmount = 0,
            pairsBetAmount = 0,
            tripleBetAmount = 0,
            dealerHand,
        } = oNewRound;
        if ((_id == oOldRound._id) || !dealerHand?.points) { 
            return;
        }
        // 清空旧信息，同时隐藏小气泡 
        Object.assign(oWinningInfo, {
            ...oWinningEmptyObj,
        });
        const hasWon = pairsWinAmount || tripleWinAmount;
        if (!hasWon) return;
        Object.assign(oWinningInfo, {
            pairsMulty: Math.round(pairsWinAmount / pairsBetAmount) || 0,
            tripleMulty: Math.round(tripleWinAmount / tripleBetAmount) || 0,
            createdAt: Date.now(), 
            visible: true, // 控制可见性
        });
        // isDev && console.log('游戏 pro 获奖：', deepCopy(oNewRound), deepCopy(oWinningInfo)); 
        toClose(oWinningInfo.createdAt); // 延时关闭 
    },{
        deep: true,
    },
);

function toClose(ts){
    let iFadeOutDelay = 1800;
    if (isDev) iFadeOutDelay *= 5;
    setTimeout(()=>{
        if (oWinningInfo.createdAt != ts) return;
        oWinningInfo.visible = false; // 关闭
    }, iFadeOutDelay);
}

</script>

<style scoped src="../style/blackjack-wrapper.scss"></style>



<!-- ↓ 原版备份，2024.04.26 16:28:53 星期五  -->
<!--
enum PlusStatus {
    SuitedTrips = 100,
    StraightFlush = 40,
    ThreeOfAKind = 30,
    Straight = 10,
    Flush = 5,
    Deafault = 0,
}
enum PairPlus {
    PerfectPair = 25,
    ColouredPair = 12,
    MixedPair = 6,
    NoPair = 0,
}
watch(
    () => props.round,
    (newVal, oldVal) => {
        console.log("新旧游戏ID：", newVal._id, '=>', oldVal._id); 
        if (newVal._id == oldVal._id) return;
        oWinningInfo.isShowPlus = false;
        oWinningInfo.isShowPair = false;
        const {dealerHand, firstHand} = props.round; 
        if (!dealerHand?.cards?.length) return;   
        const [dealerHandChar] = dealerHand.cards[0];
        const [firstHandChar] = firstHand.cards[0];
        const [firstHandChar2] = firstHand.cards[1];
        const collectHands = [dealerHandChar, firstHandChar, firstHandChar2];
        const resultPlus = get21Plus3Result(collectHands);
        const resultPair = getPairType(props.round.firstHand.cards);
        if (resultPlus > 0) {
            oWinningInfo.isShowPlus = true;
            oWinningInfo.plusData = resultPlus;
            // setTimeout(() => {
            //     oWinningInfo.isShowPlus = false;
            // }, iFadeOutDelay);
        }
        if (resultPair > 0) {
            oWinningInfo.isShowPair = true;
            oWinningInfo.pairData = resultPair;
            // setTimeout(() => {
            //     oWinningInfo.isShowPair = false;
            // }, iFadeOutDelay);
        }
    },{
        deep: true,
    },
);

function get21Plus3Result(cards) {
    cards.sort();

    // Helper function to convert card value to numeric value
    function cardValue(card) {
        if (card === 'A') return 1; // Ace
        else if (isNaN(card)) return 10; // J, Q, K
        else return parseInt(card);
    }

    // Calculate the numeric values of cards
    const numericCards = cards.map((card) => cardValue(card));

    // Check for suited trips
    if (numericCards[0] === numericCards[1] && numericCards[1] === numericCards[2]) {
        return PlusStatus.SuitedTrips;
    }

    // Check for straight flush
    if (
        numericCards[1] - numericCards[0] === 1 &&
        numericCards[2] - numericCards[1] === 1 &&
        numericCards[0] % 13 === numericCards[1] % 13 &&
        numericCards[1] % 13 === numericCards[2] % 13
    ) {
        return PlusStatus.StraightFlush;
    }

    // Check for three of a kind
    if (numericCards[0] === numericCards[1] || numericCards[1] === numericCards[2]) {
        return PlusStatus.ThreeOfAKind;
    }

    // Check for straight
    if (numericCards[1] - numericCards[0] === 1 && numericCards[2] - numericCards[1] === 1) {
        return PlusStatus.Straight;
    }

    // Check for flush
    if (cards[0].charAt(1) === cards[1].charAt(1) && cards[1].charAt(1) === cards[2].charAt(1)) {
        return PlusStatus.Flush;
    }

    return PlusStatus.Deafault;
}

function getPairType(cards) {
    // Check if the first two cards are of the same rank and suit (Perfect Pair)
    if (cards[0].charAt(0) === cards[1].charAt(0) && cards[0].charAt(1) === cards[1].charAt(1)) {
        return PairPlus.PerfectPair;
    }
    // Check if the first two cards are of the same rank but different suits (Coloured Pair)
    else if (
        cards[0].charAt(0) === cards[1].charAt(0) &&
        cards[0].charAt(1) !== cards[1].charAt(1)
    ) {
        return PairPlus.ColouredPair;
    }
    // Check if the first two cards are of the same rank but different suits (Mixed Pair)
    else if (
        cards[0].charAt(0) === cards[1].charAt(0) &&
        cards[0].charAt(1) !== cards[1].charAt(1)
    ) {
        return PairPlus.MixedPair;
    }
    // No pair found
    else {
        return PairPlus.NoPair;
    }
} -->
